export default "__VITE_ASSET__0779ff8d__"